module.exports = __webpack_public_path__ + "static/media/Jubel-Medium.db9d53d8.woff2";